import { createFileRoute } from "@tanstack/react-router";

const ProjectHoursRoute = (): null => null;

export const Route = createFileRoute("/_app/settings/projects/$id/hours/")({
	component: ProjectHoursRoute,
});
